"use strict";
exports.__esModule = true;
exports.VehicleType = void 0;
var VehicleType;
(function (VehicleType) {
    /** A road vehicle designed to carry passengers (use this for vehicles carrying more than about ten people). */
    VehicleType["Bus"] = "bus";
    /** A form of rail transport consisting of a series of connected vehicles that generally run along a railroad track to transport passengers. */
    VehicleType["Train"] = "train";
    /** A type of road vehicle used for transporting goods or people (use this for vehicles transporting a dozen people or fewer). */
    VehicleType["Van"] = "van";
    /** A van that transports users from a transport hub (usually airport) to an individual destination like a hotel. This should only be used for vehicles smaller than standard intercity coaches. */
    VehicleType["Shuttle"] = "shuttle";
    /** A vessel used to carry passengers, and sometimes vehicles and cargo, across a body of water. */
    VehicleType["Ferry"] = "ferry";
    /** A small personal vehicle, usually a contractor for a carsharing service. */
    VehicleType["Carpool"] = "carpool";
})(VehicleType = exports.VehicleType || (exports.VehicleType = {}));
